import React from 'react'
import AlertTable from './AlertTable'

const Alerts = ({ riskAssessmentData, emergencyRiskAssessmentData }) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 mx-auto">
      {/* Row 1 */}
      <div className="card col-span-1 lg:col-span-2">
        <h3>Static Alerts</h3>
        <AlertTable riskAssessmentData={riskAssessmentData} />
      </div>
      {/* Row 2 */}
      <div className="card col-span-1 lg:col-span-2">
        <h3>Real Time Alerts</h3>
        <AlertTable riskAssessmentData={emergencyRiskAssessmentData} />
      </div>
    </div>
  );
};

export default Alerts